// extracted by mini-css-extract-plugin
export default {"wrap-images":"ImageGallery_wrap-images__bR0wk","wrap-image":"ImageGallery_wrap-image__Vcg0f"};